import {  t  } from "@/client/libs/dummy-i18n";
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from "@stackmorph/ui";
import { useState } from "react";

import { PricingModal } from "@/client/components/pricing-modal";
import { useUser } from "@/client/services/user";

export const PremiumSettings = () => {
  const { user } = useUser();
  const [isPricingOpen, setIsPricingOpen] = useState(false);

  const handleBuyAddon = async (addonId: string) => {
    // Similar logic to handleUpgrade in PricingModal
    // Detect country, create order, handle payment
    // For MVP, just alert
    alert(`Buying addon: ${addonId}. Payment integration same as Premium upgrade.`);
  };

  return (
    <>
      <PricingModal isOpen={isPricingOpen} setIsOpen={setIsPricingOpen} />
      <div className="space-y-6">
        <div>
          <h3 className="text-2xl font-semibold leading-none tracking-tight">{t`Premium & Add-ons`}</h3>
          <p className="text-sm text-muted-foreground">{t`Manage your subscription and purchases.`}</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{t`Subscription Status`}</CardTitle>
            <CardDescription>
              {user?.isPremium ? t`You are a Premium member.` : t`You are currently on the Free plan.`}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {!user?.isPremium && (
              <Button onClick={() => { setIsPricingOpen(true); }}>{t`Upgrade to Premium`}</Button>
            )}
            {user?.isPremium && (
              <p className="text-green-600 font-medium">✅ {t`Premium Active`}</p>
            )}
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>{t`Available Add-ons`}</CardTitle>
            <CardDescription>{t`Enhance your career with our add-on packs.`}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between rounded-lg border p-4">
              <div>
                <h4 className="font-semibold">{t`Internship Certification`}</h4>
                <p className="text-sm text-muted-foreground">{t`Get certified for your resume building skills.`}</p>
              </div>
              <Button variant="outline" onClick={() => handleBuyAddon("internship-cert")}>
                {t`Buy`}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
